import * as angular from "angular";

export function countWatchers() {
    //angular.reloadWithDebugInfo();
    var root = angular.element(document.getElementsByTagName("body"));

    var watchers = [];

    var f = function (element) {
        angular.forEach(["$scope", "$isolateScope"],
            function (scopeProperty) {
                if (element.data() && element.data().hasOwnProperty(scopeProperty)) {
                    angular.forEach(element.data()[scopeProperty].$$watchers,
                        function (watcher) {
                            watchers.push(watcher);
                        });
                }
            });

        angular.forEach(element.children(),
            function (childElement) {
                f(angular.element(childElement));
            });
    };

    f(root);

    // Remove duplicate watchers
    var watchersWithoutDuplicates = [];
    angular.forEach(watchers,
        function (item) {
            if (watchersWithoutDuplicates.indexOf(item) < 0) {
                watchersWithoutDuplicates.push(item);
            }
        });

    console.log(watchersWithoutDuplicates.length);
}

export function listWatchers(root?) {
    root = angular.element(root || document.documentElement);
    var watcherCount = 0;

    function getElemWatchers(element) {
        var isolateWatchers = getWatchersFromScope(element.data().$isolateScope);
        var scopeWatchers = getWatchersFromScope(element.data().$scope);
        var watchers = scopeWatchers.concat(isolateWatchers);

        angular.forEach(element.children(), (childElement) => {
            watchers = watchers.concat(getElemWatchers(angular.element(childElement)));
        });

        return watchers;
    }

    function getWatchersFromScope(scope) {
        if (scope) {
            return scope.$$watchers || [];
        } else {
            return [];
        }
    }

    return getElemWatchers(root);
}

export function analyseWatchers(root?) {
    const watchers = listWatchers(root);

    var countArray = [];

    watchers.forEach(watch => {
        console.log(watch);
        const expLabel = watch.exp.toString();

        if (countArray[expLabel]) {
            countArray[expLabel]++;
        } else {
            countArray[expLabel] = 1;
        }
    });

    console.log(countArray);
}


export function showStats() {
    var a = document.createElement("script");
    a.src = "https://rawgit.com/kentcdodds/ng-stats/master/dist/ng-stats.js";
    a.onload = function () { (window as any).showAngularStats({ logDigest: true }) };

    document.head.appendChild(a);
};

export function analyseWatchers2() {
    //https://gist.github.com/DTFagus/3966db108a578f2eb00d

    var root = $(document.getElementsByTagName('html'));
    var watchers = [];
    var attributes = [];
    var attributes_with_values = [];
    var elements = [];
    var elements_per_attr = [];
    var scopes = [];

    function include(arr, obj) {
        return (arr.indexOf(obj) != -1);
    }

    function is_not_duplicate(arr, obj) {
        if (typeof arr == "undefined") {
            return true;
        } else {
            if (include(arr, obj)) {
                return false;
            } else {
                return true;
            }
        }

    }

    var f = function (element) {
        if (element.data().hasOwnProperty('$scope')) {

            if (typeof scopes[element.data().$scope.$id] == "undefined") {
                scopes[element.data().$scope.$id] = true;

                angular.forEach(element.data().$scope.$$watchers, function (watcher) {
                    watchers.push(watcher);
                    for (var index = 0; index < element[0]['attributes'].length; ++index) {
                        if (is_not_duplicate(elements_per_attr[element[0]['attributes'][index].nodeName], element.data().$scope.$id)) {

                            if (typeof elements[element[0]['attributes'][index].nodeName] == "undefined") {
                                elements[element[0]['attributes'][index].nodeName] = [];
                            }

                            elements[element[0]['attributes'][index].nodeName].push({
                                element: "(Scope " + element.data().$scope.$id + "): " + element[0].outerHTML,
                                element_obj: element[0],
                                element_data: element.data(),
                                relevant_watcher: watcher,
                                current_value: watcher.last
                            }

                            );
                            if (typeof elements_per_attr[element[0]['attributes'][index].nodeName] == "undefined") {
                                elements_per_attr[element[0]['attributes'][index].nodeName] = [];
                            }
                            elements_per_attr[element[0]['attributes'][index].nodeName].push(element.data().$scope.$id);
                        }
                    }
                });
            }
        }
        angular.forEach(element.children(), function (childElement) {
            f($(childElement));
        });
    };
    f(root);
    console.log("####################");
    console.log("Analysing Watchers");
    console.log("####################");
    console.log(" ");
    console.log("Watchers:");
    console.log(watchers.length);
    console.log("----------------------------------------------");
    console.log("Watched Elements grouped by attribute");
    console.log(elements);
}

export function countHTMLElements(string) {
    var elements = document.getElementsByTagName('*');
    var foundCount = 0;

    for (var i = 0, il = elements.length; i < il; i++) {
        if (!elements[i].textContent || !elements[i].textContent.match(string)) {
            continue;
        }

        foundCount++;
    }

    return 'Count: ' + foundCount;
}

window["showStats"] = showStats;
window["countWatchers"] = countWatchers;
window["analyseWatchers"] = analyseWatchers;
window["analyseWatchers2"] = analyseWatchers2;
window["listWatchers"] = listWatchers;
window["countHTMLElements"] = countHTMLElements;
